import { useEffect, useState } from "react";
import { Trophy, User, Crown } from "lucide-react";
import Loading from "../../components/UI/Loading/Loading";
import { authService } from "../../services/api";
import "./index.css";

function formatBRL(value) {
  return Number(value).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

function formatRankingRevenue(player) {
  if (player?.has_public_revenue === false) {
    return "R$ ******";
  }
  return formatBRL(player?.total_approved ?? 0);
}

export default function Ranking() {
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Fetch ranking data
  useEffect(() => {
    const fetchRanking = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await authService.ranking();

        if (response.data.success) {
          setRanking(response.data.data);
          setStartDate(response.data.start_date);
          setEndDate(response.data.end_date);
        } else {
          setError(response.data.error || 'Erro ao carregar ranking');
        }
      } catch (err) {
        console.error('Erro ao buscar ranking:', err);
        setError(err.message || 'Erro ao carregar dados');
      } finally {
        setLoading(false);
      }
    };

    fetchRanking();
  }, []);


  if (error) return <p className="error-message">{error}</p>;

  // Separar top 3 do resto
  const top3 = ranking.slice(0, 3);
  const rest = ranking.slice(3);

  return (
    <div className="page">
      <header className="ranking-header" style={{ color: "white" }}>
        <h1>
          <Trophy /> Ranking de Players
        </h1>
        <div className="ranking-period">
          Competição: {startDate} até {endDate}
        </div>
      </header>

      {loading ? (
        <Loading text="Carregando..." />
      ) : (
        <>
          {ranking.length > 0 ? (
            <>
              {/* Pódio - Top 3 */}
              {top3.length > 0 && (
                <div className="podium-container">
                  {/* 2º Lugar - Esquerda */}
                  {top3[1] && (
                    <div className="podium-place podium-second">
                      <div className="podium-avatar">
                        <User />
                      </div>
                      <div className="podium-position">2</div>
                      <div className="podium-card">
                        <div className="podium-name">{top3[1].display_name}</div>
                        <div className="podium-revenue">{formatRankingRevenue(top3[1])}</div>
                      </div>
                    </div>
                  )}

                  {/* 1º Lugar - Centro */}
                  {top3[0] && (
                    <div className="podium-place podium-first">
                      <div className="podium-crown">
                        <Crown />
                      </div>
                      <div className="podium-avatar podium-avatar-first">
                        <User />
                      </div>
                      <div className="podium-position podium-position-first">1</div>
                      <div className="podium-card podium-card-first">
                        <div className="podium-badge">
                          <Trophy /> REI DO RANKING
                        </div>
                        <div className="podium-name">{top3[0].display_name}</div>
                        <div className="podium-revenue podium-revenue-first">{formatRankingRevenue(top3[0])}</div>
                      </div>
                    </div>
                  )}

                  {/* 3º Lugar - Direita */}
                  {top3[2] && (
                    <div className="podium-place podium-third">
                      <div className="podium-avatar">
                        <User />
                      </div>
                      <div className="podium-position">3</div>
                      <div className="podium-card">
                        <div className="podium-name">{top3[2].display_name}</div>
                        <div className="podium-revenue">{formatRankingRevenue(top3[2])}</div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Tabela - Resto do ranking */}
              {rest.length > 0 && (
                <div className="ranking-table" style={{ marginTop: '3rem' }}>
                  <table>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Player</th>
                        <th>Faturamento</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rest.map((player, index) => {
                        const position = index + 4;

                        return (
                          <tr key={player.display_name ?? index}>
                            <td>
                              <div className="rank-position">
                                {position}
                              </div>
                            </td>
                            <td>
                              <div className="player-name">{player.display_name}</div>
                            </td>
                            <td>
                              <div className="player-revenue">
                                {formatRankingRevenue(player)}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          ) : (
            <div className="empty-state">
              <Trophy />
              <h3>Nenhum dado disponível</h3>
              <p>Ainda não há players com faturamento aprovado no período.</p>
            </div>
          )
          }</>
      )}
    </div>
  );
}